<template>
  <div
    class="relative group"
    @mouseover="openDropdown"
    @mouseleave="closeDropdown"
  >
    <div class="flex items-center font-bold p-2 cursor-pointer">
      {{ label }}
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
      </svg>
    </div>

    <transition name="fade">
      <div
        v-show="isActive"
        class="absolute left-0 mt-2 w-48 bg-white rounded shadow-lg py-2 z-20"
      >
        <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="link.to"
          class="block px-4 py-2 text-sm hover:bg-gray-100"
        >
          {{ link.label }}
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  label: String,
  links: Array // [{ to: '/about', label: 'About' }, ...]
})

const isActive = ref(false)

function openDropdown() {
  isActive.value = true
}

function closeDropdown() {
  isActive.value = false
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}
</style>
